module.exports = __webpack_public_path__ + "static/img/wuxian-3.8fa4f249.png";